import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DownloadIcon from '@mui/icons-material/Download';
import imgUrl from '../assets/images/imgUrl.js';
import { Link as ScrollLink } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Home', type: 'scroll', target: 'home' },
  { label: 'About', type: 'scroll', target: 'aboutGlobalReach' },
  { label: 'Products', type: 'scroll', target: 'products' },
  { label: 'Career', type: 'scroll', target: 'career' },
  { label: 'Contact us', type: 'scroll', target: 'contact-us' },
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openResources, setOpenResources] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDownload = (fileType) => {
    handleCloseMenu();

    if (fileType === "full") {
      const pdfUrl = "/duretechnologies/dure-brochure-new.pdf";
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "Dure Brochure";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } 
    // Brief will be added later
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Drawer menu
  const drawer = (
  <Box onClick={(e) => e.stopPropagation()} sx={{ textAlign: 'center' }}>
    <img
      src={imgUrl.dureLogo}
      alt="Logo"
      style={{ height: 30, margin: '16px auto', cursor: 'pointer' }}
      onClick={() => {
        handleDrawerToggle();
        navigate('/');
      }}
    />

    <List>
      {navItems.map((item, index) => (
        <ListItem key={index} disablePadding>
          <ScrollLink
            to={item.target}
            smooth={true}
            duration={500}
            offset={-70}
            spy={true}
            activeClass="activeScroll"
          >
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ScrollLink>
        </ListItem>
      ))}

      {/* Resources Main Item */}
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => setOpenResources(!openResources)}
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontWeight: 500,
          }}
        >
          <ListItemText primary="Resources" />
        </ListItemButton>
      </ListItem>

        {/* Submenu Items */}
        {openResources && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 , paddingLeft:'10px' , paddingRight:'10px'}} className="resourceTab">
            <Button
              fullWidth
              variant="contained"
              className='resourcesButton'
              onClick={() => handleDownload('full')}
              sx={{
                backgroundColor: '#6e1b9b',
                color: '#fff',
                borderRadius: 10,
                textTransform: 'none',
                fontWeight: 500,
                px: 3,
                '&:hover': { backgroundColor: '#4a148c' },
              }}
              startIcon={<DownloadIcon />}
            >
              Full Brochure
            </Button>

            <Button
              fullWidth
              variant="contained"
              className='resourcesButton'
              onClick={() => handleDownload('brief')}
              sx={{
                backgroundColor: '#6e1b9b',
                color: '#fff',
                borderRadius: 10,
                textTransform: 'none',
                fontWeight: 500,
                px: 3,
                '&:hover': { backgroundColor: '#4a148c' },
              }}
              startIcon={<DownloadIcon />}
              href=""
              download
            >
              Brief
            </Button>
          </Box>
        )}
    </List>
  </Box>
);

  return (
    <>
      <AppBar
        position="fixed"
        color="transparent"
        elevation={0}
        className={`HeaderSection ${isScrolled ? 'scrolled' : ''}`}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={imgUrl.dureLogo}
              alt="Logo"
              style={{ height: 30, marginRight: 12, cursor: 'pointer' }}
              onClick={() => navigate('/')}
            />
          </Box>

          {isMobile ? (
            <IconButton color="inherit" edge="start" onClick={handleDrawerToggle}>
              <MenuIcon className="menuIcon" />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {navItems.map((item, index) => (
                <ScrollLink
                  key={index}
                  to={item.target}
                  smooth={true}
                  duration={500}
                  offset={-70}
                  spy={true}
                  activeClass="activeScroll"
                >
                  <Button sx={{ color: '#fff', textTransform: 'none' }}>
                    {item.label}
                  </Button>
                </ScrollLink>
              ))}

              {/* Resources Dropdown */}
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenMenu}
                sx={{
                  ml: 2,
                  borderRadius: 10,
                  px: 3,
                  fontSize: '14px !important',
                  boxShadow: 'none',
                  backgroundColor: '#c170ff',
                  '&:hover': { backgroundColor: '#c170ff' },
                }}
              >
                Resources
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    borderRadius: 3,
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
                    px: 1,
                    backgroundColor:'#f2f2f2'
                  },
                }}
              >
                <MenuItem onClick={() => handleDownload("full")}>
                  <Typography sx={{ flexGrow: 1 , color:'#8d8d8d'}}>Full Brochure</Typography>
                  {/* <DownloadIcon fontSize="small" /> */}
                  <img src={imgUrl.downloadIcon} alt='Download' style={{marginLeft:'10px'}}></img>
                </MenuItem>
                <MenuItem onClick={() => handleDownload("brief")}>
                  <Typography sx={{ flexGrow: 1  , color:'#8d8d8d'}}>Brief</Typography>
                  {/* <DownloadIcon fontSize="small" /> */}
                  <img src={imgUrl.downloadIcon} alt='Download' style={{marginLeft:'10px'}}></img>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        className="mobileDrawer"
        onClose={handleDrawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: 240,
            paddingTop: 2,
            backgroundColor: 'rgb(51 71 125 / 80%)',
            color: '#fff',
          },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Header;
